export const NZ_SALES_PORTFOLIO_URL = 'https://lookerstudio.google.com/reporting/86aa3ad7-be54-4e02-9056-cb3a937b352e/page/p_cs4p53hy5c';

export const AU_SALES_PORTFOLIO_URL = 'https://lookerstudio.google.com/reporting/c0134591-1d29-4da4-bb99-eb29e12f3016/page/p_cs4p53hy5c';

export const CIN7_URL = 'https://inventory.dearsystems.com/';

export const CRM_BOARD_URL = {
  NZ: 'https://garageproject.monday.com/boards/6059857353',
  AU: 'https://garageproject.monday.com/boards/8232498483',
};

/** Selectable regions for a run. One or both may be chosen. */
export const REGION_OPTIONS = [
  { label: 'New Zealand', value: 'NZ' },
  { label: 'Australia', value: 'AU' },
];

export const REGION_LABELS = {
  NZ: 'New Zealand',
  AU: 'Australia',
};

/**
 * Segment distribution config — order, display label and colour.
 * The API's summary_json uses display-cased keys (e.g. "At Risk"), but the axios
 * response interceptor camelises object keys ("At Risk" -> "atRisk"). Both the
 * camelised `key` and the original `label` are checked when reading counts so the
 * UI is resilient to whichever form the backend serialises.
 */
export const SEGMENTS = [
  { key: 'champions', label: 'Champions', color: '#52c41a' },
  { key: 'developing', label: 'Developing', color: '#1890ff' },
  { key: 'core', label: 'Core', color: '#13c2c2' },
  { key: 'atRisk', label: 'At Risk', color: '#fa8c16' },
  { key: 'dormant', label: 'Dormant', color: '#8c8c8c' },
  { key: 'new', label: 'New', color: '#722ed1' },
];

/** Read a segment count regardless of whether keys were camelised or left display-cased. */
export const getSegmentCount = (segments, segment) => {
  if (!segments || typeof segments !== 'object') return 0;
  const candidates = [segment.key, segment.label, segment.label.toLowerCase()];
  for (let i = 0; i < candidates.length; i += 1) {
    const value = segments[candidates[i]];
    if (value != null) return value;
  }
  return 0;
};

/** Match a segment config from a display label, camelised key, or unknown string. */
export const getSegmentByLabel = (value) => {
  if (value == null || value === '') return null;
  const raw = String(value);
  return SEGMENTS.find((segment) => (
    segment.label === raw
    || segment.key === raw
    || segment.label.toLowerCase() === raw.toLowerCase()
    || segment.key.toLowerCase() === raw.toLowerCase()
  )) || null;
};

export const getSegmentColor = (value) => getSegmentByLabel(value)?.color;

/** Canonical display order (Champions first). Unknown labels sort last. */
export const getSegmentSortIndex = (value) => {
  const segment = getSegmentByLabel(value);
  if (!segment) return SEGMENTS.length;
  return SEGMENTS.indexOf(segment);
};

/** Run status enum -> Ant tag colour + human label. */
export const RUN_STATUS_CONFIG = {
  scoring: { label: 'Scoring', color: 'processing' },
  scored: { label: 'Scored', color: 'cyan' },
  awaiting_approval: { label: 'Awaiting approval', color: 'gold' },
  applying: { label: 'Applying', color: 'blue' },
  completed: { label: 'Completed', color: 'green' },
  failed: { label: 'Failed', color: 'red' },
  cancelled: { label: 'Cancelled', color: 'default' },
};

/** Statuses where the run is still doing work (used to drive live polling fallbacks). */
export const ACTIVE_RUN_STATUSES = ['scoring', 'scored', 'awaiting_approval', 'applying'];

/** Change-log filter options. */
export const CHANGE_SYSTEM_OPTIONS = [
  { label: 'Cin7', value: 'cin7' },
  { label: 'Monday', value: 'monday' },
];

/** Match backend change status enum: pending | ok | failed | skipped. */
export const CHANGE_STATUS_OPTIONS = [
  { label: 'OK', value: 'ok' },
  { label: 'Failed', value: 'failed' },
  { label: 'Skipped', value: 'skipped' },
];
